export default __webpack_public_path__ + "static/small-image-applozic-2-cd11b36b247ec2b35652115a694a95e1.png";